module.exports = __webpack_public_path__ + "static/media/intro.11f29016.mp3";